export const isSupportingCompany = (user) => Boolean(user?.supportingCompany);

export const getEffectiveCompanyId = (user) => {
  if (!user) {
    return null;
  }
  return (
    user.supportingCompany?.id
    || user.active_company_id
    || user.company_id
    || user.companies?.[0]?.id
    || null
  );
};

export const hasCompanyAccess = (user) => {
  if (!user) {
    return false;
  }
  if (user.role === 'super_admin') {
    return !!getEffectiveCompanyId(user);
  }
  return !!getEffectiveCompanyId(user);
};

export const needsOnboarding = (user) => user?.needsOnboarding === true;

export const PENDING_INVITATION_KEY = 'pendingInvitationToken';

export const storePendingInvitation = (token) => {
  if (token) {
    sessionStorage.setItem(PENDING_INVITATION_KEY, token);
  }
};

export const consumePendingInvitation = () => {
  const token = sessionStorage.getItem(PENDING_INVITATION_KEY);
  if (token) {
    sessionStorage.removeItem(PENDING_INVITATION_KEY);
  }
  return token;
};

export const getPendingInvitation = () => sessionStorage.getItem(PENDING_INVITATION_KEY);

const resolveUserDestination = (user, pendingInvitation) => {
  if (user?.role === 'super_admin' && !getEffectiveCompanyId(user)) {
    return '/super-admin';
  }

  if (needsOnboarding(user)) {
    return pendingInvitation
      ? `/onboarding?invitation=${pendingInvitation}`
      : '/onboarding';
  }

  if (user?.needsProfileCompletion) {
    return '/users/edit';
  }

  if (pendingInvitation) {
    return `/accept-invitation?invitation=${pendingInvitation}`;
  }
  if (user?.invitationsCount > 0 && !getEffectiveCompanyId(user)) {
    return '/accept-invitation';
  }
  if (!getEffectiveCompanyId(user)) {
    return '/onboarding';
  }
  return '/dashboard';
};

export const getAppEntryPath = (user) => resolveUserDestination(user, null);

export const getPostAuthPath = (user) => {
  const pendingInvitation = consumePendingInvitation();
  return resolveUserDestination(user, pendingInvitation);
};
